var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btnitem",on:{"click":_vm.signUp}},[_c('img',{staticStyle:{"width":"20px","height":"20px"},attrs:{"src":require("@/assets/linshiyonggong/baoming@2x.png")}}),_c('span',[_vm._v("立即报名")])])
}
var staticRenderFns = []

export { render, staticRenderFns }